import { GetExpensesResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useExpenses = (tripId: string | undefined) => {
    return useQuery<GetExpensesResponse>({
        queryKey: queryKeys.expenses(tripId),
        queryFn: async () => {
            if (!tripId) {
                throw new Error('Trip ID is required')
            }
            const response = await api.get<GetExpensesResponse>(`/trips/${tripId}/expenses`)
            return response.data
        },
        enabled: !!tripId,
        retry: 1,
    })
}
